var map = {
	"./AURORA.svg": 1518,
	"./AVALANCHE.svg": 1519,
	"./AVAX.svg": 1520,
	"./AXELAR.svg": 1521,
	"./AXL.svg": 1522,
	"./AXL/AXE.svg": 1523,
	"./AXL/axelar-icon.svg": 1524,
	"./BINANCE.svg": 1525,
	"./BSC.svg": 1526,
	"./BTC.svg": 1527,
	"./COSMOSHUB.svg": 1528,
	"./CRESCENT.svg": 1529,
	"./E-MONEY.svg": 1530,
	"./ETH.svg": 1531,
	"./ETHEREUM.svg": 1532,
	"./FANTOM.svg": 1533,
	"./FETCH.svg": 1534,
	"./FTM.svg": 1535,
	"./INJECTIVE.svg": 1536,
	"./JUNO.svg": 1537,
	"./KUJIRA.svg": 1538,
	"./MOONBEAM.svg": 1539,
	"./OSMO.svg": 1540,
	"./OSMOSIS.svg": 1541,
	"./POLYGON.svg": 1542,
	"./SECRET.svg": 1543,
	"./SEI.svg": 1544,
	"./TERRA.svg": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;